import { CSSProperties } from 'react';

// The Luzmo dashboard always leaves a fixed 42px gap on the right side of its content.
// Making the component 42px wider than its container and clipping the overflow hides that gap,
// so the dashboard visually appears to fill 100% of the parent container width.
export const LUZMO_SCREEN_MODE_OVERFLOW_OFFSET_PX = 42;

export const getLuzmoDashboardWidth = (): string =>
  `calc(100% + ${LUZMO_SCREEN_MODE_OVERFLOW_OFFSET_PX}px)`;

export const LOADER_STYLES = (): CSSProperties => ({ display: 'none' });
export const CONTAINER_LOADER_STYLE = { display: 'none' };
